import { render, staticRenderFns } from "./OverviewNav.vue?vue&type=template&id=08ce086a&scoped=true&"
import script from "./OverviewNav.vue?vue&type=script&lang=js&"
export * from "./OverviewNav.vue?vue&type=script&lang=js&"
import style0 from "./OverviewNav.vue?vue&type=style&index=0&id=08ce086a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ce086a",
  null
  
)

export default component.exports